import React from 'react';
import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { AlertProps } from './_interface';
import { OptionProps } from '../components/atoms/_interface';
import { DateObject } from 'react-multi-date-picker';
import { RangeDateProps } from '../popups/_interface';
import { ConstructionInfoProps } from '../pages/_interface';
import { SelectProps } from './_interface';

// 새로운 저장소 객체 생성
export function newPersistAtom(key: string = 'sessionStorage') {
  // 스토리지에 저장하는 기능
  const { persistAtom } = recoilPersist({
    key: key,
    storage: sessionStorage || localStorage || undefined, // localStorage 또는 sessionStorage
  });
  return persistAtom;
}

export const alertState = atom<AlertProps>({
  key: 'alertState',
  default: {
    type: 'alert',
    title: '',
    desc: '',
    active: false,
  },
});

export const loaderState = atom({
  key: 'loaderState',
  default: {
    show: false,
  },
});

/* 파일 업로드 progressBar 로더 */
export const progressState = atom<any>({
  key: 'progressState',
  default: {
    show: false,
    fileName: '',
    domId: 'progress',
  },
});

export const statisticsOptionState = atom<OptionProps[]>({
  key: 'statisticsOptionState',
  default: [
    { text: '최근1개월', value: 1, active: true },
    { text: '최근3개월', value: 2, active: false },
    { text: '전체', value: 3, active: false },
    { text: '직접입력', value: 4, active: false },
  ],
});

export const statisticsDateState = atom<RangeDateProps>({
  key: 'statisticsDateState',
  default: {
    from: new DateObject().toFirstOfMonth(),
    to: new DateObject().toLastOfMonth(),
  },
});

const isBrowserDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
// 초기 테마 저장 (시스템 기본값)
if (!sessionStorage.getItem('theme')) {
  sessionStorage.setItem('theme', isBrowserDarkMode ? 'dark' : 'light');
}
export const themeState = atom<string>({
  key: 'themeState',
  default: isBrowserDarkMode ? 'dark' : 'light',
});

export const constructionInfoState = atom<ConstructionInfoProps>({
  key: 'constructionInfo',
  default: {
    address: '',
    subContractor: [],
    contractor: [],
    owner: [],
    projectName: '',
    projection: '',
    facilityKinds: [],
  },
  effects_UNSTABLE: [newPersistAtom('constructionInfo')], // persist 적용
});

export const siteListState = atom<SelectProps[]>({
  key: 'siteList',
  default: [],
  // effects_UNSTABLE: [newPersistAtom('siteList')],
});

export const solutionState = atom<string[]>({
  key: 'solutionList',
  default: [],
});

// 임시 기능: 간섭발생 좌표 (이동할 좌표 저장)
export const alertPositionState = atom({
  key: 'alertPosition',
  default: {
    position: {
      x: 0,
      y: 0,
    },
  },
});

type AlertItem = {
  position: { x: number; y: number };
  show: boolean;
  active: boolean;
};

export const alertListState = atom<AlertItem[]>({
  key: 'alertList',
  default: [],
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const saved = sessionStorage.getItem('alertList');
      // 1. 초기값 복원
      if (saved) {
        try {
          const savedData = JSON.parse(saved);

          if (Array.isArray(savedData)) {
            const restored = savedData.map((item) => ({
              position: item.position,
              show: item.show,
              active: false, // 항상 초기화
            }));

            setSelf(restored);
          } else {
            console.warn('alertList 저장된 데이터가 배열이 아닙니다.', savedData);
            // 혹시 잘못된 데이터면 초기화하지 않고 default 유지
          }
        } catch (e) {
          console.error('alertList JSON 파싱 에러', e);
          // 파싱 에러 발생 시 무시 (초기화)
        }
      }

      // 2. 값 변경될 때 저장 (setState)
      onSet((newValue, _, isReset) => {
        if (isReset) {
          sessionStorage.removeItem('alertList');
        } else {
          const toSave = newValue.map((item: any) => ({
            position: item.position, // 위치도 저장
            show: item.show, // show만 저장
            // active는 저장 안 함
          }));

          sessionStorage.setItem('alertList', JSON.stringify(toSave));
        }
      });
    },
  ],
});
